export const Stats = ({ className }: any) => {
	return (
		<svg
			width="23"
			height="32"
			viewBox="0 0 23 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<path
				d="M17.9474 27.8421V18.7632"
				stroke="#16DE3C"
				stroke-width="2.42105"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M12 28V13.4737"
				stroke="#16A2DE"
				stroke-width="2.42105"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M6.05261 15.7368L12 6.47368L16.9473 12.1053"
				stroke="#C8C8C8"
				stroke-width="0.605263"
			/>
			<path
				d="M6.05261 27.8421V22.3947"
				stroke="#DF1737"
				stroke-width="2.42105"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<circle cx="6.05263" cy="15.7368" r="1.21053" fill="#DF1737" />
			<circle cx="17.2105" cy="12.6842" r="1.21053" fill="#365ADA" />
			<circle cx="12" cy="6.47368" r="2" fill="#16A2DE" />
			<circle cx="6" cy="15.4737" r="2" fill="#DF1737" />
			<circle cx="18" cy="12.4737" r="2" fill="#16DE3C" />
		</svg>
	);
};
